import { render, staticRenderFns } from "./VrRefundList.vue?vue&type=template&id=73a55584&scoped=true&"
import script from "./VrRefundList.vue?vue&type=script&lang=js&"
export * from "./VrRefundList.vue?vue&type=script&lang=js&"
import style0 from "./VrRefundList.vue?vue&type=style&index=0&id=73a55584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a55584",
  null
  
)

export default component.exports